var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lidaCard"},[_c('div',{staticClass:"no-permission-content"},[_vm._v("此操作员无权限访问该页面")])])}]

export { render, staticRenderFns }